import TranslatedMessage from "./TranslatedMessage";

export default TranslatedMessage;
